import React from 'react';

import { Button, Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { MagnifyIcon } from 'assets/icons';

interface DeviceFilterBarProps {
  categories: string[];
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
}

export const DeviceFilterBar = ({
  categories,
  selectedCategory,
  onSelectCategory,
  search,
  onSearchChange
}: DeviceFilterBarProps) => {
  const intl = useIntl();

  return (
    <div className="d-flex align-items-center justify-content-between gap-3 mb-4 flex-wrap">
      <div className="d-flex gap-2 flex-wrap">
        <Button
          type="button"
          variant="light"
          size="sm"
          onClick={() => onSelectCategory('all')}
          className={`rounded border-0 ${selectedCategory === 'all' ? 'bg-blue-light text-blue-light' : ''}`}
          data-test="filter-all"
        >
          {intl.formatMessage({ id: 'deviceTypeAllKey' })}
        </Button>
        {categories.map((cat) => (
          <Button
            type="button"
            variant="light"
            size="sm"
            key={cat}
            onClick={() => onSelectCategory(cat)}
            className={`rounded border-0 ${selectedCategory === cat ? 'bg-blue-light text-blue-light' : ''}`}
            data-test={`filter-${cat}`}
          >
            {intl.formatMessage({ id: cat })}
          </Button>
        ))}
      </div>

      <div className="position-relative flex-shrink-0" style={{ width: 280 }}>
        <div
          className="position-absolute d-flex align-items-center text-secondary top-50 translate-middle-y pe-none"
          style={{ left: 10 }}
        >
          <MagnifyIcon className="icon" style={{ fontSize: '14px' }} />
        </div>
        <Form.Control
          type="text"
          size="sm"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={intl.formatMessage({ id: 'deviceListSearchPlaceholderKey' })}
          className="ps-4"
          data-test="device-search"
        />
      </div>
    </div>
  );
};
